import { defineAction } from '~/prix'
import { z } from 'zod'
import heavyMachineryUpdateAction from './heavyMachineryUpdate.action.json' with { type: 'json' }
import { heavyMachineryUpdateInputObject } from '../heavyMachineryObject'

const heavyMachineryUpdateDefinition = defineAction({
  ...heavyMachineryUpdateAction,

  input: heavyMachineryUpdateInputObject,
  output: z.object({}),
})

export default heavyMachineryUpdateDefinition
